import React, { useState, useRef } from 'react'
import {
  Button,
  Box as BoxChakra,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useToast,
} from '@chakra-ui/react'
import { Store } from '@hz/stealthy-gmc-cloaker-common/api-types/store'
import { useEditStoreMutation } from '@state/apiSlice/requests';

type Props = {
  selectedStore: Store | null;
  isDisableDialogOpen: boolean;
  setIsDisableDialogOpen: (val: boolean) => void;
}

export const DisableStoreModal = ({selectedStore, isDisableDialogOpen, setIsDisableDialogOpen}: Props) => {
  const cancelRef = useRef<HTMLButtonElement>(null)
  const toast = useToast()

  const [editStore] = useEditStoreMutation()

  const handleToggleStore = async (store: Store) => {
    try {

      const result = await editStore({storeId: store.storeId, isDisabled: !store.disabled}).unwrap();
     
      if (result.success) {
        toast({
          title: `Store ${store.disabled ? 'enabled' : 'disabled'} successfully`,
          status: 'success',
          duration: 3000,
          position: 'bottom-right',
        })

       
      }
    } catch (error) {

      toast({
        title: 'Error updating store',
        description: 'Please try again later',
        status: 'error',
        duration: 5000,
        position: 'bottom-right',
      })
    }
  }

  return (
    <AlertDialog
        isOpen={isDisableDialogOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => setIsDisableDialogOpen(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent bg="gray.800" borderColor="gray.700">
            <AlertDialogHeader color="white">
              {selectedStore?.disabled ? 'Enable Store?' : 'Disable Store?'}
            </AlertDialogHeader>
            <AlertDialogBody color="gray.300">
              {selectedStore?.disabled
                ? 'Enabling this store will resume showing your content to customers of this store.'
                : 'If you disable this store, your content will no longer be shown to customers of this store until you enable it again.'}
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                variant="ghost"
                onClick={() => setIsDisableDialogOpen(false)}
                color="gray.400"
                _hover={{
                  bg: 'gray.700',
                  color: 'white',
                }}
              >
                Cancel
              </Button>
              <Button
                bg={selectedStore?.disabled ? 'green.500' : 'yellow.500'}
                color="white"
                ml={3}
                onClick={() => {
                  if (selectedStore) {
                    handleToggleStore(selectedStore)
                    setIsDisableDialogOpen(false)
                  }
                }}
                _hover={{
                  bg: selectedStore?.disabled ? 'green.600' : 'yellow.600',
                }}
              >
                {selectedStore?.disabled ? 'Enable Store' : 'Disable Store'}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
  )
}
